import Config from '@/modules/config/models/Config'

export default {
  namespaced: true,
  getters: {
    value(state) {
      return k =>
        state.data[k] && state.data[k].value ? state.data[k].value : null
    }
  },
  actions: {
    async get({ _dispatch }) {
      try {
        const config = await this._vm.$axios.get('api/configs')
        Config.insert({ data: config }, { root: true })

        return config
      } catch (error) {
        throw error
      }
    }
  }
}
